import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#f93b5d',
        text1: '#ffffff',
        text2: '#232632',
        text3: '#6b6a75',
        text4: '#f8f9fb',
        text5: '#f93b5d'
      },
      dark: {
        primary: '#f93b5d',
        text1: '#ffffff',
        text2: '#232632',
        text3: '#6b6a75',
        text4: '#f8f9fb',
        text5: '#f93b5d'
      }
    }
  }
});
